import { flag, integer, list, optionalText, record, text } from '../../../shared/decode'
import { emptyText } from '../../../shared/candidates'
import type { SalesPoint, SalesPointAudit, SalesPointDirectory, SalesPointRegister, SourceRegisters } from '../model/types'

function pointRegister(raw: unknown, name: string): SalesPointRegister {
  const v = record(raw, name)
  return { resourceId: text(v.resourceId, name), resourceName: emptyText(v.resourceName, name), registerKey: text(v.registerKey, name), registerName: emptyText(v.registerName, name), shopName: emptyText(v.shopName, name) }
}
export function decodeSalesPoint(raw: unknown, name = 'point'): SalesPoint {
  const v = record(raw, name)
  return { id: text(v.id, name), name: text(v.name, name), version: integer(v.version, name), archived: flag(v.archived, name), canEdit: flag(v.canEdit, name), registers: list(v.registers, name, pointRegister) }
}
export function decodeSalesPointDirectory(raw: unknown): SalesPointDirectory {
  const v = record(raw, 'directory')
  return { points: list(v.points, 'points', decodeSalesPoint), sources: list(v.sources, 'sources', (entry, name) => {
    const item = record(entry, name)
    return { id: text(item.id, name), name: text(item.name, name), kind: optionalText(item.kind, name) ?? '' }
  }), canManage: flag(v.canManage, 'canManage') }
}
export function decodeSourceRegisters(raw: unknown): SourceRegisters {
  const v = record(raw, 'registers')
  return { items: list(v.items, 'items', (entry, name) => {
    const item = record(entry, name)
    return { key: text(item.key, name), name: emptyText(item.name, name), shopKey: emptyText(item.shopKey, name), shopName: emptyText(item.shopName, name), organizationName: optionalText(item.organizationName, name), archived: flag(item.archived, name), pointId: optionalText(item.pointId, name), pointName: optionalText(item.pointName, name) }
  }), complete: flag(v.complete, 'complete'), note: optionalText(v.note, 'note') }
}
export function decodeSalesPointAudit(raw: unknown): SalesPointAudit[] {
  return list(raw, 'audit', (entry, name) => { const v = record(entry, name); return { operationId: text(v.operationId, name), actor: text(v.actor, name), at: text(v.at, name), before: emptyText(v.before, name), after: emptyText(v.after, name) } })
}
